import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../../services/api';
import Header from '../common/Header';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [devInfo, setDevInfo] = useState(null);

  const heroBgUrl = `${process.env.PUBLIC_URL}/images/circular_economy_home.png`;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setDevInfo(null);
    if (!email) {
      setError('Please enter your email address.');
      return;
    }
    try {
      setLoading(true);
      const resp = await requestPasswordReset(email.trim());
      setSent(true);
      // In DEBUG the backend may return uid/token for convenience
      if (resp && (resp.uid && resp.token)) {
        setDevInfo({ uid: resp.uid, token: resp.token });
      }
    } catch (err) {
      setError(err?.message || 'Failed to request password reset');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Header currentView="register" />
      <div className="min-h-[90vh] flex items-center justify-center px-4">

        <div className=" flex flex-col lg:flex-row items-center justify-center p-6 border border-cyan-500 bg-cyan-500 rounded-xl shadow">

        <div className="w-full max-w-md bg-cyan-500 p-6 border-cyan- rounded-xl">
         <img src={heroBgUrl} alt="Circular Economy Home" className="max-w-full max-h-full object-cover" />
        </div>

      <div className="w-full max-w-md bg-white p-6 rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-1 text-gray-800">Reset your password</h2>
        <p className="text-sm text-gray-600 mb-4">Enter your account email and well send a reset link.</p>
        {error && <div className="mb-3 p-2 text-sm rounded bg-red-50 text-red-700 border border-red-200">{error}</div>}
        {sent ? (
          <div className="p-3 rounded bg-green-50 text-green-700 border border-green-200 text-sm">
            If an account exists for {email}, a password reset email has been sent.
            {devInfo && (
              <div className="mt-2 p-2 rounded bg-yellow-50 text-yellow-800 border border-yellow-200">
                <div className="font-semibold">DEV ONLY (DEBUG):</div>
                <div className="text-xs break-all">uid: {devInfo.uid}</div>
                <div className="text-xs break-all">token: {devInfo.token}</div>
                <div className="text-xs">Use the link in your console email or go to Reset Password page.</div>
              </div>
            )}
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-3">
            <div>
              <label className="block text-sm text-gray-700 mb-1">Email</label>
              <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="you@example.com" />
            </div>
            <button type="submit" disabled={loading} className={`w-full py-2 rounded text-white font-medium ${loading ? 'bg-gray-400' : 'bg-cyan-600 hover:bg-cyan-700'}`}>{loading ? 'Sending…' : 'Send reset link'}</button>
          </form>
        )}
        <div className="mt-4 text-sm">
          <Link to="/login" className="text-cyan-700 hover:underline">Back to sign in</Link>
        </div>
      </div>
      </div>

      </div>
    </div>
  );
};

export default ForgotPasswordPage;
